<template>
  <div v-if="cardioPatient" v-cloak>
    <div class="dropdown top-right">
      <!-- dev begin -->
      <button type="button" class="btn btn-secondary" v-if="isDev || isQa"
        :disabled="cardioPatient.screeningStatus === 5" @click="cardioPatient.screeningStatus = 5">
        dev 💻 aktivera indexhantering
      </button>
      <!-- dev end -->
      <button type="button" class="btn btn-primary dropdown-toggle"
        data-toggle="dropdown" :disabled="cardioPatient.screeningStatus !== 5">
        Indexhantering
      </button>
      <div class="dropdown-menu margin-right-vw">
        <a class="dropdown-item" @click="inviteIdx(2)" :disabled="cardioPatient.doNotWantToBecomeIndexPatient">Bjuda in som index (<u>gen pos</u>)</a>
        <a class="dropdown-item" @click="inviteIdx(1)" :disabled="cardioPatient.doNotWantToBecomeIndexPatient">Bjuda in som index (<u>gen neg</u>)</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="discloseIdx()">Vill ej ingå som index</a>
        <a class="dropdown-item" @click="endPatientParticipation()">Vill avsluta sin delaktighet</a>
      </div>
    </div>
    <div class="container bg--cardio">
      <div class="flex-wrapper">
        <h5 class="text-muted margin-left-vw"># {{ cardioPatient.personId }}</h5>
        <small>
        <router-link class="text-muted edit-link" :to="{ name: 'editcardiopatient', params: { id: cardioPatient.personId }}">
          ✏️ Redigera
        </router-link>
        </small>
      </div>
      <h2 class="text-muted margin-left-vw">
        {{ cardioPatient.firstName + ' ' + cardioPatient.lastName }}
      </h2>
      <p>
        <span class="text-muted margin-left-vw" v-text="formatPnr(cardioPatient.ssn)"></span>
        <span class="text-muted">({{ getAge }} år)</span>
        <span class="text-muted">({{ getGender }})</span>
      </p>
      <p class="text-muted margin-left-vw">
        <strong>Status</strong>: {{ getStatus(cardioPatient.screeningStatus) }}
      </p>
      <p v-if="cardioPatient.doNotWantToBecomeIndexPatient" class="text-muted margin-left-vw">
        <strong>Vill inte bli inbjuden som index</strong>
      </p>
      <div class="row margin-left-0">
        <div class="col col-sm-3">
          <strong>Kontakt</strong>
          <p>
            <i v-if="cardioPatient.phoneNumber && !cardioPatient.phoneNumber.startsWith('0')">+46</i>
            {{ cardioPatient.phoneNumber || '-' }} <br />
            {{ cardioPatient.email || '-' }}
          </p>
        </div>
        <div class="col col-sm-3">
          <strong>Folkbokförd</strong>
          <p v-if="populationInfo">
            {{ populationInfo.streetAddress || '-' }} <br />
            {{ populationInfo.postalCode || '-' }} <br />
            {{ populationInfo.city || '-' }}
          </p>
          <div v-if="!populationInfo" class="div-loader">Hämtar</div>
          <p v-if="!hasPopulationInfo">
            Kunde inte hämta från NAVET.
            <span class="text-primary cursor-pointer" @click="getFromNavet()">Hämta igen</span>
          </p>
        </div>
        <div class="col col-sm-5">
          <div>
            <strong>Registrerad av:</strong><br />
            {{ cardioPatient.clinicianName || '-' }}<span v-if="cardioPatient.clinicName">,</span>
            {{ cardioPatient.clinicName }}
          </div>
          <div class="clearfix--min"></div>
          <div>
            <strong>Ursprungsklinik</strong><br />
            {{ cardioPatient.originalClinic || '-' }}
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <nav class="navbar navbar-expand-sm bg-light">
        <!-- Links -->
        <ul class="navbar-nav">
          <li class="nav-item active_btm">
            <a class="nav-link text-primary" href="#">Diagnosunderlag</a>
          </li>
        </ul>
      </nav>
      <div class="clearfix"></div>
      <div class="wrapper">
        <!-- GET /screeninganswer -->
        <div class="card card-screening journal-card light-red">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Screeningfrågor/svar</strong></p>
            <div class="row">
              <div class="col-lg-6 text-muted">
                <p><u>Fråga</u></p>
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningreasonforinclusion'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningreasonforinclusion')).question }}
                </span>
                <span v-else>Fråga om inkludering ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningvegan'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningvegan')).question }}
                </span>
                <span v-else>Fråga om vegansk kost ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiet'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiet')).question }}
                </span>
                <span v-else>Fråga om diet ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningegg'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningegg')).question }}
                </span>
                <span v-else>Fråga om äggintag ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningsmoking'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningsmoking')).question }}
                </span>
                <span v-else>Fråga om rökning ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1')).question }}
                </span>
                <span v-else>Fråga om diabetes typ 1 ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2')).question }}
                </span>
                <span v-else>Fråga om diabetes typ 2 ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeninghypertension'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeninghypertension')).question }}
                </span>
                <span v-else>Fråga om hypertoni ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio')).question }}
                </span>
                <span v-else>Fråga om medicinering ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningbmi'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningbmi')).question }}
                </span>
                <span v-else>Fråga om midjemått, längd, vikt samt BMI ej tillgänglig</span>
              </div>
              <div class="col-lg-6 text-muted">
                <p><u>Svar</u></p>
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningreasonforinclusion'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningreasonforinclusion')).reason.answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningvegan'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningvegan')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiet'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiet')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningegg'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningegg')).eggs.answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningsmoking'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningsmoking')).smoking.answer }}
                  <small v-if="getSpecificScreeningAnswer(getFieldId('screeningsmoking')).amount">
                    / Antal per dag: {{ getSpecificScreeningAnswer(getFieldId('screeningsmoking')).amount }}
                  </small>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeninghypertension'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeninghypertension')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio')).answer }}
                  <small class="text-muted cursor-pointer"
                    data-toggle="modal" data-target="#medicineModal" data-backdrop="keyboard"
                    v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio')).answer === 'Ja'">
                    [Visa läkemedel]
                  </small>
                </span>
                <span v-else>-</span>
                <div v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio'))"
                  class="modal" id="medicineModal" aria-labelledby="medicineModal" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <h5 class="modal-title" id="exampleModalLabel">Läkemedel</h5>
                      <button type="button" class="close close-modal-btn" data-dismiss="modal">&times;</button>
                      <div class="modal-body">
                        <div v-for="(d, i) in getSpecificScreeningAnswer(getFieldId('screeningmedicine_cardio')).drugs" :key="i">
                          <table class="table" v-if="d.dose !== 0 && d.unit !== 0 && d.amountperday !== 0">
                            <tr>
                              <th>Namn</th>
                              <th>Dos</th>
                              <th>Enhet</th>
                              <th>Frekvens</th>
                            </tr>
                            <tr>
                              <td>{{ toTitleCase(d.name) || toTitleCase(d.value) }}</td>
                              <td>{{ d.dose }}</td>
                              <td>{{ d.unit }}</td>
                              <td>{{ d.amountperday || d.injectionsperweek }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningbmi'))">
                  Midjemått: {{ getSpecificScreeningAnswer(getFieldId('screeningbmi')).values.bellyCircumference }} cm <br />
                  Längd: {{ getSpecificScreeningAnswer(getFieldId('screeningbmi')).values.height }} cm <br />
                  Vikt: {{ getSpecificScreeningAnswer(getFieldId('screeningbmi')).values.weight }} kg <br />
                  BMI: {{ getSpecificScreeningAnswer(getFieldId('screeningbmi')).summary }}
                </span>
                <span v-else>-</span>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- DLCN -->
        <div class="card dlcn-card journal-card">
          <div class="card-body" v-if="!dlcn">
            <div class="div-loader">Hämtar DLCN</div>
          </div>
          <div class="card-body" v-if="dlcn && data">
            <div class="row">
                <div class="col-sm-4">
                  <p class="text-dark pull-left" v-html="data.clinicCardio.dlcnHeader"></p>
                </div>
                <div class="col-sm-4"></div>
            </div>
            <div class="row">
              <div class="col-sm-10">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><strong>Grupp 1: Familjeanamnes</strong></span>
                  </div>
                  <select class="form-control pull-right" v-model.number="dlcn.group1" @change="calculateDLCNsummary()">
                    <option :value="null">Välj från grupp 1</option>
                    <option
                      v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupOne"
                      v-html="dlcnText"
                      :key="dlcnText"
                      :value="{ name: dlcnText, points: parseInt(points) }"
                      :title="toElementTitle(dlcnText)">
                    </option>
                  </select>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><strong>Grupp 2: Patientens anamnes</strong></span>
                  </div>
                  <select class="form-control pull-right" v-model.number="dlcn.group2" @change="calculateDLCNsummary()">
                    <option :value="null">Välj från grupp 2</option>
                    <option
                      v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupTwo"
                      v-html="dlcnText"
                      :key="dlcnText"
                      :value="{ name: dlcnText, points: parseInt(points) }"
                      :title="toElementTitle(dlcnText)">
                    </option>
                  </select>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><strong>Grupp 3: Patientens fysikaliska status</strong></span>
                  </div>
                  <select class="form-control pull-right" v-model.number="dlcn.group3" @change="calculateDLCNsummary()">
                    <option :value="null">Välj från grupp 3</option>
                    <option
                      v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupThree"
                      v-html="dlcnText"
                      :key="dlcnText"
                      :value="{ name: dlcnText, points: parseInt(points) }"
                      :title="toElementTitle(dlcnText)">
                    </option>
                  </select>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><strong>Grupp 4: Patientens LDL-kolesterol (obehandlat)</strong></span>
                  </div>
                  <select class="form-control pull-right" v-model.number="dlcn.group4" @change="calculateDLCNsummary()">
                    <option :value="null">Välj från grupp 4</option>
                    <option
                      v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupFour"
                      v-html="dlcnText"
                      :key="dlcnText"
                      :value="{ name: dlcnText, points: parseInt(points) }"
                      :title="toElementTitle(dlcnText)">
                    </option>
                  </select>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><strong>Grupp 5: Genetiskt test</strong></span>
                  </div>
                  <select class="form-control pull-right" v-model.number="dlcn.group5" @change="calculateDLCNsummary()">
                    <option :value="null">Välj från grupp 5</option>
                    <option
                      v-for="(points, dlcnText) in data.clinicCardio.dlcnGroupFive"
                      v-html="dlcnText"
                      :key="dlcnText"
                      :value="{ name: dlcnText, points: parseInt(points) }"
                      :title="toElementTitle(dlcnText)">
                    </option>
                  </select>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bold-text" v-html="data.clinicCardio.dlcnSummary"></span>
                  </div>
                  <input type="text" class="font-weight-bold form-control pull-right" id="dlcnSummary"
                    v-model="dlcn.summary" disabled>
                </div>
                <button class="btn btn-primary btn-md btn-right" @click="sendUpdatedDLCN()">Uppdatera DLCN</button>
                <div class="clearfix--min"></div>
                <p v-html="data.clinicCardio.dlcnText"></p>
              </div>
              <div class="col-sm"></div>
              <div class="col-sm"></div>
              <div class="col-sm"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- POST /cardio/referralstatus { statusType: 1 } -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Remiss Endokrinmottagningen</strong></p>
            <div class="row">
              <div class="col-sm-6">
                <label>
                  <input type="checkbox" @change="referralStateChange($event, 1)"
                    :checked="cardioPatient.referralStatuses[0].status">
                  &nbsp; Remiss skickad till Endokrinmottagningen
                </label>
              </div>
              <div class="col-sm"></div>
              <div class="col-sm"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- POST /cardio/referralstatus { statusType: 7 } -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Remiss Kardiologen</strong></p>
            <div class="row">
              <div class="col-sm-6">
                <label>
                  <input type="checkbox" @change="referralStateChange($event, 7)"
                    :checked="cardioPatient.referralStatuses[6].status">
                  &nbsp; Remissvar skickad till kardiologen
                </label>
              </div>
              <div class="col-sm"></div>
              <div class="col-sm"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- GET /bloodtestassessment - bloodTest -->
        <div class="card journal-card" id="bloodtestassessment-card">
          <div class="card-body" v-if="!bloodtest">
            <div class="clearfix"></div>
            <p class="pull-left" v-if="!bloodtest">Inga provsvar inlagda</p>
          </div>
          <div class="card-body" v-if="bloodtest">
            <div class="row">
              <div class="col-sm-6">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th>
                        <strong>Enligt journaluppgifter högsta uppmätta obehandlade LDL-kolesterol</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ bloodtest.ldlHighestMeasured || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p class="text-dark pull-left">
              <strong>Senaste resultatet för blodfetter</strong>
            </p>
            <div class="row">
              <div class="col-sm">
                <p class="text-dark pull-left" v-if="bloodtest">
                  <u>P</u>rovtagningsdatum: {{ new Date(bloodtest.testDate).toLocaleDateString() }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th><strong>LDL värde från Friedewalds</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ bloodtest.ldlFriedewalds || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-1">
                <span class="filter icon cursor-pointer"
                  v-if="bloodtest" v-popover:tooltip.top="'LDL kolesterol beräknat enligt Friedewalds formel'">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
              </div>
              <div class="col-sm-4">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th><strong>Beräknat obehandlat LDL kolesterol</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ bloodtest.ldlUntreated || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-1">
                <span class="filter icon cursor-pointer"
                  v-if="bloodtest" v-popover:tooltip.top="'Framräknat obehandlat LDL kolesterol baserat på aktuell behandling'">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
              </div>
            </div>
            <p class="text-dark pull-left"><strong>Labprovsvar</strong></p>
            <div class="row">
              <div class="col-sm-9">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th>Typ</th>
                      <th>Värde</th>
                      <th>Referensintervall</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>LDL</td>
                      <td v-if="!bloodtest.ldlUncalculated">-</td>
                      <td v-if="bloodtest.ldlUncalculated">
                        {{ bloodtest.ldlUncalculated }} {{ bloodtest.ldlUnit }}
                      </td>
                      <td>{{ bloodtest.ldlReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>HDL</td>
                      <td>{{ bloodtest.hdl }} {{ bloodtest.hdlUnit }}</td>
                      <td>{{ bloodtest.hdlReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Triglycerider</td>
                      <td>{{ bloodtest.triglycerider }} {{ bloodtest.triglyceriderUnit }}</td>
                      <td>{{ bloodtest.triglyceriderReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Totalkolesterol</td>
                      <td>{{ bloodtest.totalKolesterol }} {{ bloodtest.totalKolesterolUnit }}</td>
                      <td>{{ bloodtest.totalKolesterolReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Lipoprotein (a)</td>
                      <td v-if="!bloodtest.lipoProteinA">-</td>
                      <td v-if="bloodtest.lipoProteinA">{{ bloodtest.lipoProteinA }} {{ bloodtest.lipoProteinAUnit }}</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-2"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- POST /cardio/geneticTestDecision -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Bedömning gällande genetiskt test</strong></p>
            <!-- Patientmallar -->
            <select class="form-control form-control--templates"
              v-if="isGeneticTestDecisionPatient && patientTemplates"
              v-model="geneticTestTemplate" @change="copyGeneticTestDecisionTemplate()">
              <option :value="0">{{ chooseGeneticTestDecisionTemplate }}</option>
              <option
                v-for="(cntnt, hdr) in patientTemplates.clinicMisc['patientTemplatesDecisionCardio' + regionCode]"
                v-html="hdr"
                :value="cntnt"
                :key="cntnt"
                :title="toElementTitle(cntnt)">
              </option>
            </select>
            <!-- Journalmallar -->
            <select class="form-control form-control--templates"
              v-if="!isGeneticTestDecisionPatient && journalTemplates"
              v-model="geneticTestTemplate" @change="copyGeneticTestDecisionTemplate()">
              <option :value="0">{{ chooseGeneticTestDecisionTemplate }}</option>
              <option
                v-for="(cntnt, hdr) in journalTemplates.clinicMisc['journalTemplatesDecisionCardio' + regionCode]"
                v-html="hdr"
                :value="cntnt"
                :key="hdr"
                :title="toElementTitle(cntnt)">
              </option>
            </select>
            <div class="row">
              <div class="col-sm-3 pull-left">
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.geneticTestDecision.geneticTestDecision" :value="1">
                      &nbsp; Gå vidare med gentest
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.geneticTestDecision.geneticTestDecision" :value="2">
                      &nbsp; Ej gentest / Ej FH
                  </label>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="form-group">
                  <div v-if="!cardioPatient.geneticTestDecision" class="div-loader">Laddar</div>
                  <label for="geneticTestDecisionPatientText">
                    <VueToggles
                      @click="isGeneticTestDecisionPatient = !isGeneticTestDecisionPatient"
                      :value="isGeneticTestDecisionPatient"
                      height="30"
                      width="90"
                      checkedText="patient"
                      uncheckedText="journal"
                      checkedBg="#b4d455"
                      uncheckedBg="lightgrey"
                    />
                  </label>
                  <textarea
                    class="form-control"
                    id="geneticTestDecisionPatientText"
                    rows="6"
                    v-if="cardioPatient.geneticTestDecision"
                    v-model="cardioPatient.geneticTestDecision.geneticTestDecisionPatientText">
                  </textarea>
                  <div class="clearfix"></div>
                  <br /><br />
                  <button
                  class="btn btn-btm width-50 btn-md btn-block btn-primary"
                  @click="sendGeneticTestDecision()"
                  v-if="cardioPatient.geneticTestDecision && isGeneticTestDecisionPatient"
                  :disabled="cardioPatient.geneticTestDecision.geneticTestDecision === 0">
                    Skicka till patient
                  </button>
                  <span class="badge badge-secondary badge-pat" v-if="patientDecision">✓ Skickat till pat.</span>
                  <button
                  class="btn btn-btm width-50 btn-md btn-block btn-primary"
                  @click="saveGeneticTestJournal()"
                  v-if="cardioPatient.geneticTestDecision && !isGeneticTestDecisionPatient"
                  :disabled="!cardioPatient.geneticTestDecision.geneticTestDecisionPatientText || isGeneticTestDecisionPatient">
                    Spara vald journalmall
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-primary alert-gentestdecision">
          <strong>Bedömningen är nu skickad.</strong>
        </div>
        <div class="clearfix"></div>
        <div class="card journal-card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <p class="text-dark pull-left"><strong>Gentestprovsvar</strong></p>
                <div class="checkbox">
                  <label>
                    <!-- TODO: Ersätt text nedanför: &nbsp; Patient kontaktad angående gentest -->
                    <input type="checkbox" @change="referralStateChange($event, 2)"
                      :checked="cardioPatient.referralStatuses[1].status">
                    &nbsp; Patient kontaktad ang gentest
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" @change="referralStateChange($event, 3)"
                      :checked="cardioPatient.referralStatuses[2].status">
                    &nbsp; Gentestremiss skapad och skickad
                  </label>
                </div>
              </div>
              <div class="col-sm-4 pull-left">
                <p class="text-dark"><strong>Bedömning gällande mutation</strong></p>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.mutation.geneticTestAssessment" :value="1">
                    &nbsp; Genmutation
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.mutation.geneticTestAssessment" :value="2">
                    &nbsp; Ej genmutation
                  </label>
                </div>
              </div>
              <div class="col-sm-4"></div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="pull-left" for="mutationlong">Långt mutationsnamn + kort mutationsnamn:</label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <button class="input-group-text" title="Återställ" @click="mutation = 0">
                        <small>Återställ</small>
                      </button>
                    </div>
                    <select
                      class="form-control"
                      v-model="mutation"
                      v-if="intervalLists"
                      @change="assignMutations()">
                      <option :value="0">Välj mutation</option>
                      <option
                        v-for="(mutationshort, mutationlong) in intervalLists.clinicMisc.mutationlist"
                        :value="{ long: mutationlong, short: mutationshort }"
                        :key="mutationlong">
                        {{ mutationlong }} {{ mutationshort }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group form-group-select">
                  <label for="diagnosisfacility">Diagnosställe:</label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <button class="input-group-text" title="Återställ" @click="diagnosisLocation = 0">
                        <small>Återställ</small>
                      </button>
                    </div>
                    <select class="form-control" @change="assignLocation()"
                      v-model="diagnosisLocation" v-if="intervalLists">
                      <option :value="0">Välj diagnosställe</option>
                      <option v-for="(region, facility) in intervalLists.clinicMisc.mutationFacilityList"
                        :value="facility" :key="facility">
                        {{ facility }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group" v-show="mutation === 0">
                  <label class="pull-left" for="mutationlong">Långt mutationsnamn:</label>
                  <input type="text" class="form-control" id="mutationlong" @input="mutation = 0"
                    v-if="cardioPatient" v-model="cardioPatient.mutation.mutationLong">
                  <span class="text-dark" v-if="!cardioPatient">-</span>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group" v-show="diagnosisLocation === 0">
                  <label class="pull-left" for="diagnosislocation">Diagnosställe:</label>
                  <input
                    type="text"
                    class="form-control"
                    id="diagnosislocation"
                    v-if="cardioPatient"
                    v-model="cardioPatient.mutation.diagnosisLocation">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <div class="form-group">
                  <label class="pull-left" for="diagnosisdate">Diagnosdatum:</label>
                  <date-pick v-if="cardioPatient" v-model="cardioPatient.mutation.diagnosisDate"
                  id="diagnosisdate" :displayFormat="'YYYY-MM-DD'"
                  :inputAttributes="{name: cardioPatient.mutation.diagnosisDate,
                    id: cardioPatient.mutation.diagnosisDate, class: ['form-control'],
                    readonly: true, placeholder: 'Välj diagnosdatum'}">
                  </date-pick>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group" v-show="mutation === 0">
                  <label class="pull-left" for="mutationshort">Kort mutationsnamn:</label>
                  <input type="text" class="form-control" id="mutationshort" @input="mutation = 0"
                    v-if="cardioPatient" v-model="cardioPatient.mutation.mutation">
                  <span class="text-dark" v-if="!cardioPatient">-</span>
                </div>
              </div>
              <div class="col-sm-5">
                <button class="btn btn-btm btn-block btn-primary"
                :disabled="!cardioPatient.mutation.geneticTestAssessment"
                @click="sendGeneticTest()">Spara värden</button>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-primary alert-gentest">
          <strong>Värdena är nu ändrade samt sparade.</strong>
        </div>
        <div class="clearfix"></div>
        <!-- POST /cardio/referralstatus { statusType: 4,5,6 } -->
        <div class="card journal-card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <p class="text-dark"><strong>Utredning</strong></p>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" @change="referralStateChange($event, 4)"
                      :checked="cardioPatient.referralStatuses[3].status">
                    &nbsp; Kallelse till videobesök skickad
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" @change="referralStateChange($event, 5)"
                      :checked="cardioPatient.referralStatuses[4].status">
                    &nbsp; Videobesök genomfört
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" @change="referralStateChange($event, 6)"
                      :checked="cardioPatient.referralStatuses[5].status">
                    &nbsp; Patient vill ej utredas vidare
                  </label>
                </div>
              </div>
              <div class="col-sm-3"></div>
              <div class="col-sm-3"></div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="card journal-card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4">
                <p class="text-dark"><strong>Beslut</strong></p>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.diagnosis.fhDiagnosisValue" :value="2">
                    &nbsp; Familjär hyperkolesterolemi
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.diagnosis.fhDiagnosisValue" :value="4">
                    &nbsp; Ej Familjär hyperkolesterolemi
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="cardioPatient"
                      v-model="cardioPatient.diagnosis.fhDiagnosisValue" :value="3">
                      &nbsp; Ej individuell bedömning - låg sannolikhet för FH
                  </label>
                </div>
                <button class="btn btn-primary btn-sm" @click="sendFHDiagnosis()"
                  :disabled="!cardioPatient.diagnosis.fhDiagnosisValue">
                  Spara beslut
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-primary alert-bottom-right alert-cardio alert-referral">
          <strong>Valet är nu sparat.</strong>
        </div>
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-sm-3">
            <button class="btn btn-primary btn-block" @click="confirmLeave()">
              Tillbaka
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { getScreeningStatus } from '../plugins/screening_status'
import { request } from '../plugins/datocms'
import { inRange } from '../plugins/numberhelper'
import FieldId from '../plugins/fieldid'
import DatePick from 'vue-date-pick'
import $ from 'jquery'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'patientcardio',
  components: {
    DatePick
  },
  props: ['id'],
  data () {
    return {
      data: null,
      patientTemplates: null,
      journalTemplates: null,
      intervalLists: null,
      cardioPatient: null,
      screeningAnswers: null,
      populationInfo: null,
      bloodtest: null,
      fhdiagnosis: null,
      hasPopulationInfo: null,
      mutation: 0,
      diagnosisLocation: 0,
      geneticTestTemplate: 0,
      dlcn: null,
      isGeneticTestDecisionPatient: true,
      patientDecision: false,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      regionCode: localStorage.getItem('regioncode'),
      saveJournal: '<strong>Mallen är nu sparad!</strong>',
      chooseGeneticTestDecisionTemplate: 'Välj patientmall (kopieras vid val)'
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    isObjDirty (o) {
      return Object.keys(o || {}).some(function (x) {
        return o[x] === '' || o[x] === null || o[x] === 0 || typeof o[x] === 'undefined'
      })
    },
    isAllObjectsNull (obj) {
      return Object.keys(obj).every(function (x) {
        return obj[x] === null
      })
    },
    toElementTitle (str) {
      if (str) {
        let res = $('<textarea />').html(str).text()
        res = res.replace(/<[^>]*>?/gm, '')
        return res
      }
    },
    getStatus (status) {
      return getScreeningStatus(status)
    },
    getFieldId (lbl) {
      return FieldId(lbl)
    },
    formatPnr (ssn) {
      if (ssn) {
        const pnr = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return pnr
      }
      return '-'
    },
    assignMutations () {
      if (this.cardioPatient.mutation) {
        this.cardioPatient.mutation.mutationLong = this.mutation.long
        this.cardioPatient.mutation.mutation = this.mutation.short
      }
    },
    assignLocation () {
      if (this.cardioPatient.mutation) {
        this.cardioPatient.mutation.diagnosisLocation = this.diagnosisLocation
      }
    },
    calculateDLCNsummary () {
      if (this.dlcn) {
        const points1 = this.dlcn.group1 ? this.dlcn.group1.points : 0
        const points2 = this.dlcn.group2 ? this.dlcn.group2.points : 0
        const points3 = this.dlcn.group3 ? this.dlcn.group3.points : 0
        const points4 = this.dlcn.group4 ? this.dlcn.group4.points : 0
        const points5 = this.dlcn.group5 ? this.dlcn.group5.points : 0
        const sum = points1 + points2 + points3 + points4 + points5
        this.dlcn.summary = sum
      }
    },
    copyGeneticTestDecisionTemplate () {
      const clinician = localStorage.getItem('fullname') ? localStorage.getItem('fullname') : 'Läkare'
      const center = localStorage.getItem('clinicName') ? localStorage.getItem('clinicName')
        : 'Medicinsk enhet Endokrinologi \n Karolinska universitetssjukhuset'
      if (this.geneticTestTemplate === 0) {
        this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText = ''
      } else {
        this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText = ''
        this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText = this.geneticTestTemplate
        if (this.isGeneticTestDecisionPatient) {
          this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText =
            this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText +
            '\n\n' + clinician + '\n' + center
        } else {
          this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText =
            this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText
              .split('Bedömning').join('\n\n Bedömning')
              .split('Åtgärd').join('\n Åtgärd')
              .split('Diagnos').join('\n Diagnos')
              .split('Tilläggskod').join('\n Tilläggskod')
        }
      }
    },
    saveGeneticTestJournal () {
      const journal = this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText
      localStorage.setItem('genTestCardioJournal', journal)
      $('.alert-assessment').html(this.saveJournal).show().delay(4000).fadeOut()
    },
    inviteIdx (patType) {
      sessionStorage.setItem('patientToBeConverted', JSON.stringify({
        type: 'cardio',
        idxPatType: patType,
        data: {
          ldl: (this.bloodtest && this.bloodtest.ldlHighestMeasured) ? this.bloodtest.ldlHighestMeasured : null,
          dlcn: (this.dlcn && this.dlcn.summary > 0) ? this.dlcn.summary : ''
        },
        id: this.$props.id
      }))
      this.$router.push('/newidx')
    },
    discloseIdx () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        axios._patch(config.cardioUri + config.doNotWantToBecomeIndexPatientUri + '?PersonId=' + this.$props.id).then(res => {
          if (res) {
            $('.alert-cardio').show().delay(4000).fadeOut()
            setTimeout(() => {
              this.$router.go()
            }, 3000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not disclose patient: ' + error)
          }
        })
      }
    },
    endPatientParticipation () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        axios._delete(config.cardioUri + config.abortScreeningUri + '?PersonId=' + this.$props.id).then(res => {
          if (res) {
            $('.alert-cardio').show().delay(4000).fadeOut()
            setTimeout(() => {
              this.$router.go()
            }, 3000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not end patient participation: ' + error)
          }
        })
      }
    },
    checkForGeneticTestDecision (decision) {
      if (decision && decision.geneticTestDecision !== 0 && decision.geneticTestDecisionPatientText !== null) {
        this.patientDecision = true
      }
    },
    prePopulateReferenceIntervals (age, gender) {
      if (inRange(age, 0, 1)) {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[0]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[0]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[0]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[0]
      } else if (inRange(age, 1, 14)) {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[0]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Kvinna') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[1]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[2]
      } else if (inRange(age, 14, 17) && gender === 'Man') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[2]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[3]
      } else if (inRange(age, 18, 30) && gender === 'Kvinna') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[4]
      } else if (inRange(age, 18, 30) && gender === 'Man') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[4]
      } else if (inRange(age, 31, 50) && gender === 'Kvinna') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[5]
      } else if (inRange(age, 31, 50) && gender === 'Man') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[5]
      } else if (inRange(age, 51, 120) && gender === 'Kvinna') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[6]
      } else if (inRange(age, 51, 120) && gender === 'Man') {
        this.bloodtest.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
        this.bloodtest.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[6]
      }
    },
    async getCardioPatientById () {
      let loader = this.$loading.show()
      axios._get(config.cardioUri + '/byId?PersonId=' + this.$props.id).then(response => {
        this.cardioPatient = response.data.cardioPatientData
        this.checkForGeneticTestDecision(this.cardioPatient.geneticTestDecision)
        this.getFromNavet()
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get cardiopatient by id ' + this.$props.id + ', Error: ' + error)
          loader.hide()
        }
      })
    },
    async getBloodTest () {
      const temp = {
        testDate: null,
        ldlHighestMeasured: '',
        ldlFriedewalds: '',
        ldlUntreated: '',
        ldlUncalculated: '',
        hdl: '',
        totalKolesterol: '',
        triglycerider: '',
        lipoProteinA: '',
        ldlUnit: 'mmol/L',
        hdlUnit: 'mmol/L',
        totalKolesterolUnit: 'mmol/L',
        triglyceriderUnit: 'mmol/L',
        lipoProteinAUnit: '',
        ldlReferenceInterval: '',
        hdlReferenceInterval: '',
        totalKolesterolReferenceInterval: '',
        triglyceriderReferenceInterval: ''
      }
      axios._get(config.bloodtestUri + '?PersonId=' + this.$props.id).then(response => {
        if (response) {
          this.bloodtest = response.data.bloodTest ? response.data.bloodTest : temp
          try {
            const ldl = JSON.parse(this.bloodtest.ldl)
            this.bloodtest.ldlHighestMeasured = ldl.ldlHighestMeasured
            this.bloodtest.ldlFriedewalds = ldl.ldlFriedewalds
            this.bloodtest.ldlUntreated = ldl.ldlUntreated
            this.bloodtest.ldlUncalculated = ldl.ldlUncalculated
          } catch (msg) {
            console.log('Could not parse bloodtest LDL, assigning value directly.')
            this.bloodtest.ldlUncalculated = this.bloodtest.ldl
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get bloodtest for cardiopatient: ' + error)
        }
      })
    },
    async getScreeningAnswers () {
      axios._get(config.screeninganswerUri + '?PersonId=' + this.$props.id).then(response => {
        if (response) {
          this.screeningAnswers = response.data.answers
          this.setupDLCN()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get screeninganswers for cardiopatient: ' + error)
        }
      })
    },
    setupDLCN () {
      const DLCN = this.getSpecificScreeningAnswer(this.getFieldId('screeningdlcn'))
      this.dlcn = DLCN.dlcn
      this.dlcn.summary = DLCN.summary
    },
    getFromNavet () {
      axios.postPopulationRegistry(config.populationRegistryUri, this.cardioPatient.ssn).then((response) => {
        if (response) {
          this.populationInfo = response.data
          if (this.populationInfo) {
            this.hasPopulationInfo = true
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
        }
      })
    },
    getSpecificScreeningAnswer (fieldId) {
      if (this.screeningAnswers && this.screeningAnswers.length > 0) {
        for (let index = 0; index < this.screeningAnswers.length; index++) {
          const screeningAnswer = this.screeningAnswers[index]
          if (screeningAnswer.fieldId === fieldId) {
            const answer = JSON.parse(screeningAnswer.answer)
            return answer
          }
        }
      } else {
        return null
      }
    },
    sendUpdatedDLCN () {
      const r = confirm('Är du säker?')
      if (r) {
        let loader = this.$loading.show()
        let scrDLCN = [
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Dutch Lipid Score',
              dlcn: this.dlcn,
              summary: this.dlcn.summary,
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 5679764 // screeningdlcn
          }
        ]
        if (scrDLCN) {
          axios.postCardioPatientScreeningAnswers(config.screeninganswerUri, scrDLCN).then((response) => {
            if (response) {
              $('.alert-referral').show().delay(4000).fadeOut()
              setTimeout(() => {
                loader.hide()
                this.$router.go()
              }, 2000)
            }
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not update screeninganswer for DLCN: ' + error)
              loader.hide()
            }
          })
        }
      }
    },
    sendUpdatedTestResults () {
      const r = confirm('Är du säker på att du vill uppdatera provsvaren?')
      if (r) {
        let loader = this.$loading.show()
        this.bloodtest.personId = parseInt(this.$props.id)
        this.bloodtest.ldl = JSON.stringify({
          ldlHighestMeasured: this.bloodtest.ldlHighestMeasured,
          ldlFriedewalds: this.bloodtest.ldlFriedewalds,
          ldlUntreated: this.bloodtest.ldlUntreated,
          ldlUncalculated: this.bloodtest.ldlUncalculated
        })
        axios.putBloodTest(config.bloodtestUri, this.bloodtest).then(response => {
          if (response) {
            $('.alert-testresults').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not update bloodtest results: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendGeneticTest () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        // Send empty date as null, not empty string
        this.cardioPatient.mutation.diagnosisDate = this.cardioPatient.mutation.diagnosisDate
          ? this.cardioPatient.mutation.diagnosisDate : null
        axios.postGeneticTest(config.cardioUri + config.geneticTestUri, this.cardioPatient.mutation).then(response => {
          if (response) {
            $('.alert-gentest').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send genetictest: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendGeneticTestDecision () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const geneticTestDecision = {
          personId: this.cardioPatient.personId,
          geneticTestDecision: this.cardioPatient.geneticTestDecision.geneticTestDecision,
          geneticTestDecisionPatientText: this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText
        }
        axios.postCardioPatientGeneticTestDecision(
          config.cardioUri + config.geneticTestDecisionUri, geneticTestDecision).then(response => {
          if (response) {
            $('.alert-gentestdecision').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send genetictest decision: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendFHDiagnosis () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const diagnosis = {
          pid: this.cardioPatient.personId,
          fhValue: this.cardioPatient.diagnosis.fhDiagnosisValue,
          patientText: this.cardioPatient.diagnosis.patientText,
          clinicianId: this.cardioPatient.clinicianId
        }
        axios.postFhDiagnosis(config.cardioUri + config.fhdiagnosisUri, diagnosis).then(response => {
          if (response) {
            $('.alert-referral').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send fh diagnosis: ' + error)
            loader.hide()
          }
        })
      }
    },
    referralStateChange (event, statusType) {
      const status = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const referralStatus = {
          statusType: statusType,
          status: status,
          personId: this.cardioPatient.personId
        }
        if (referralStatus) {
          axios.postCardioPatientReferralStatus(
            config.cardioUri + config.referralStatusUri, referralStatus).then(response => {
            if (response) {
              $('.alert-referral').show().delay(4000).fadeOut()
              setTimeout(() => {
                loader.hide()
                this.$router.go()
              }, 2000)
            }
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not send referral state change: ' + error)
              loader.hide()
            }
          })
        }
      }
    },
    confirmLeave () {
      const r = confirm('Är du säker? Du kan ha osparade ändringar.')
      if (r) {
        sessionStorage.removeItem('patientToBeConverted')
        this.$router.go(-1)
      }
    }
  },
  watch: {
    isGeneticTestDecisionPatient (state) {
      if (state) {
        this.getCardioPatientById()
        this.geneticTestTemplate = 0
        this.chooseGeneticTestDecisionTemplate = 'Välj patientmall (kopieras vid val)'
      } else {
        this.chooseGeneticTestDecisionTemplate = 'Välj journalmall (kopieras vid val)'
        this.cardioPatient.geneticTestDecision.geneticTestDecisionPatientText =
          localStorage.getItem('genTestCardioJournal') ? localStorage.getItem('genTestCardioJournal') : ''
        this.geneticTestTemplate = 0
        this.cardioPatient.geneticTestDecision.geneticTestDecision = 0
      }
    }
  },
  computed: {
    getAge () {
      if (this.cardioPatient) {
        const today = new Date()
        const birthDate = new Date(this.cardioPatient.ssn.substring(0, 4) +
          '/' + this.cardioPatient.ssn.substring(4, 6) + '/' + this.cardioPatient.ssn.substring(6, 8))
        let age = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    },
    getGender () {
      if (this.cardioPatient) {
        const n = parseInt(this.cardioPatient.ssn.charAt(10))
        if (n % 2 === 0) { // Even Number
          return 'Kvinna'
        }
        return 'Man'
      }
    }
  },
  async beforeMount () {
    await this.getCardioPatientById()
    await this.getBloodTest()
    await this.getScreeningAnswers()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          clinicInfoIcon {
            triglyceridesTooHigh
          }
          clinicCardio {
            dlcnHeader
            dlcnSummary
            dlcnText
            dlcnGroupOne
            dlcnGroupTwo
            dlcnGroupThree
            dlcnGroupFour
            dlcnGroupFive
          }
        }
      `
    })
    this.patientTemplates = await request({
      query: `
        {
          clinicMisc {
            patientTemplatesDecisionCardio` + this.regionCode + `
          }
        }
      `
    })
    this.journalTemplates = await request({
      query: `
        {
          clinicMisc {
            journalTemplatesDecisionCardio` + this.regionCode + `
          }
        }
      `
    })
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
            hdlRefList
            triglyceriderRefList
            totalkolesterolRefList
            lipoproteinRefList
            mutationlist
            mutationFacilityList
          }
        }
      `
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('patientscardio/') || to.path.includes('/editcardio/')) {
      next()
    } else {
      const parts = to.path.split('/')
      const uri = '/' + parts[parts.length - 1]
      window.location.href = window.location.origin + uri
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
::-webkit-input-placeholder {
  opacity: 0.6;
}
::-moz-placeholder {
  opacity: 0.6;
}
:-ms-input-placeholder {
  opacity: 0.6;
}
:-moz-placeholder {
  opacity: 0.6;
}
input[type=checkbox] {
  transform: scale(1.5);
}
button:disabled {
  opacity: 0.3;
}
.margin-left-0 {
  margin-left: 0;
}
.width-50 {
  width: 50%;
}
.container > * {
  text-align: left;
}
.edit-link {
  vertical-align: middle;
  text-decoration: none;
  margin-left: 1em;
}
.modal-title {
  padding: 10px;
  margin-left: 5px;
}
.btn-btm {
  bottom: 1vw;
  position: absolute;
  max-width: 95%;
}
.table {
  max-width: none;
  table-layout: fixed;
  word-wrap: break-word;
}
.pull-left {
  text-align: left;
}
.pull-right {
  text-align: right;
}
.btn-right {
  float: right;
}
.form-control--templates {
  margin: 15px;
  top: 0;
  right: 0;
  position: absolute;
}
.close-modal-btn {
  margin: 15px;
  top: 0;
  right: 0;
  position: absolute;
}
.light-red, .light-red:hover {
  background: #FCF2EB !important;
}
.journal-card:hover {
  background: #bed4b4;
  border: 1px solid #abc2a0;
  color: #000;
  opacity: 1.0;
}
.journal-card {
  background: #CDE5C3;
  border: 1px solid #b7ccae;
  color: #38362E;
  opacity: 0.8;
}
.dlcn-card input:disabled, select:disabled {
  opacity: 1.0 !important;
  background-color: #f2f3f5;
}
.dlcn-card .input-group-text {
  background: rgb(236, 231, 231) !important;
  min-width: 24vw;
}
.card-body > select {
  width: 20%;
}
.card-screening {
  font-size: 90%;
}
.card-screening hr {
  margin-top: 5px;
  margin-bottom: 10px;
}
.badge-pat {
  display: flex;
  margin: -3rem;
}
.top-right {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-top: 6.5em;
  margin-right: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientCardio.vue